import type { NivelGovbr } from 'volto-ministerio-publico-federal/helpers/Servicos';

export interface ServicoEscolhido {
  '@id'?: string;
  Title?: string;
  title?: string;
  url?: string;
  externo?: boolean;
  tipo_acesso_govbr?: NivelGovbr | null;
}

export interface ServicosBuscaData {
  sobretitulo?: string;
  titulo?: string;
  tituloPrincipal?: boolean;
  texto?: string;
  pasta?: Array<{ '@id'?: string }>;
  maisProcurados?: ServicoEscolhido[];
  maisProcuradosRotulo?: string;
}

export const BUSCA_PADRAO = {
  sobretitulo: 'MPF Serviços',
  titulo: 'Serviços do MPF: resolva online, de onde estiver',
  texto:
    'Digite o que você precisa fazer ou o nome do serviço. Os serviços com o selo gov.br pedem login com a sua conta gov.br; os demais abrem direto.',
  placeholder: 'Busque por serviço',
  maisProcuradosRotulo: 'Mais procurados:',
} as const;

export const SUGESTOES_LIMITE = 6;

export const MAIS_PROCURADOS_MIN = 3;
export const MAIS_PROCURADOS_MAX = 5;

export function avisoMaisProcurados(quantidade: number): string | null {
  if (quantidade >= MAIS_PROCURADOS_MIN) return null;
  return `Escolha de ${MAIS_PROCURADOS_MIN} a ${MAIS_PROCURADOS_MAX} serviços em Mais procurados na barra lateral; hoje há ${quantidade}.`;
}

export interface Atalho {
  key: string;
  titulo: string;
  href: string;
  externo: boolean;
}

export function toAtalhos(itens?: ServicoEscolhido[]): Atalho[] {
  return (itens ?? [])
    .map((item) => ({
      key: item['@id'] ?? item.url ?? '',
      titulo: (item.Title ?? item.title ?? '').trim(),
      href: item.url ?? '',
      externo: item.externo === true,
    }))
    .filter((atalho) => atalho.titulo && atalho.href)
    .slice(0, MAIS_PROCURADOS_MAX);
}

export function mensagemSemResultados(termo: string): string {
  return `Não foi encontrado nenhum resultado para “${termo.trim()}”`;
}

export function textoDoStatus(
  total: number,
  termoValido: boolean,
  semResultados = '',
): string {
  if (!termoValido) return '';
  if (total === 0) return semResultados;
  return total === 1
    ? '1 sugestão. Use as setas para navegar.'
    : `${total} sugestões. Use as setas para navegar.`;
}
